import { ValidationField, ValidationRule } from "../../../../models";
import { validateField, allValidationRules, maskField } from "../formValidation";

export const getValidationNameAndMaskedValue = (inputName: string, inputValue: string, previousInputValue: string) => {
    const validationName = inputName.split("-")[1] ? inputName.split("-")[1] : inputName;
    const maskedValue = maskField(inputValue, previousInputValue, allValidationRules[validationName]);
    return { validationName, maskedValue };
};

export const getErrorMessage = (maskedValue: string, validationRule: ValidationRule) =>
    validateField(maskedValue, validationRule) || undefined;

export const hasErrors = (errors: ValidationField): boolean => {
    return !!Object.keys(errors).find((key: string) => {
        if (typeof errors[key] === "object") {
            return hasErrors(errors[key]);
        }
        return !!errors[key];
    });
};

export const validateInputOrFieldSet = (validationObject: ValidationField, visible: ValidationField = {}) => {
    const errors: ValidationField = {};
    Object.keys(validationObject).forEach((key) => {
        const value = validationObject[key];
        if (typeof value === "object" && value !== null) {
            errors[key] = validateInputOrFieldSet(value, visible[key]);
        } else {
            const { validationName, maskedValue } = getValidationNameAndMaskedValue(key, value, value);

            // Only validate field if its visible
            if (visible[key]) {
                errors[key] = getErrorMessage(maskedValue, allValidationRules[validationName]);
            }
        }
    });
    return errors;
};
